export const PUSH_PUBLIC_KEY = process.env.VUE_APP_PUSH_PUBLIC_KEY || '';
export const PUSH_SUBSCRIBE_PATH = process.env.VUE_APP_PUSH_SUBSCRIBE_PATH || '/rest_webpush_subscribe/';
export const PUSH_UNSUBSCRIBE_PATH = process.env.VUE_APP_PUSH_UNSUBSCRIBE_PATH || '/rest_webpush_unsubscribe/';
